import { motion } from "framer-motion";

export const ScrollReveal = ({ children, delay = 0, y = 28, className = "", ...props }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
      className={className}
      {...props}
    >
      {children}
    </motion.div>
  );
};

export const RevealHeadline = ({ lines, className = "", testId }) => {
  return (
    <span className={className} data-testid={testId}>
      {lines.map((line, i) => (
        <motion.span
          key={i}
          className="block"
          initial={{ y: 24, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 + i * 0.14, ease: [0.16, 1, 0.3, 1] }}
        >
          {line}
        </motion.span>
      ))}
    </span>
  );
};
